module.exports = __webpack_public_path__ + "img/milestone-last-active.241f0104.png";